

<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <mat-card-header>
      </mat-card-header>    
    <mat-card-content>

    @if (isLookupInProgress) {
        <p class="gray-text">Checking Flash for this Parker...</p>
    }
    @else if (hasAccessHolder && flashAccount) {
        <!-- Changing either dropdown writes straight back to Flash; there is no Save button. -->
        <div class="row">
            <div class="col-3">
                <mat-form-field appearance="fill" class="gray-text" style="width:100%">
                    <mat-label>Select Flash Profile</mat-label>
                    <mat-select [ngModel]="selectedProfileId" (ngModelChange)="onProfileChange($event)" [disabled]="isProfileUpdateInProgress">
                        @if (profileList.length === 0) {
                            <mat-option value="">Loading Profiles...</mat-option>
                        }
                        @else {
                            <!-- There is no way to clear a profile in Flash, so the placeholder disappears once one is set. -->
                            @if (selectedProfileId === '') {
                                <mat-option value="">Select Flash Profile</mat-option>
                            }
                            @for (profile of profileList; track profile.uniqueID) {
                                <mat-option [value]="profile.uniqueID">{{ profile.name }}</mat-option>
                            }
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-3">
                <mat-form-field appearance="fill" class="gray-text" style="width:100%">
                    <mat-label>Select Pool</mat-label>
                    <mat-select [ngModel]="selectedPoolName" (ngModelChange)="onPoolChange($event)" [disabled]="isProfileUpdateInProgress">
                        @if (selectedPoolName === '') {
                            <mat-option value="">Select Pool</mat-option>
                        }
                        @for (pool of poolOptions; track pool) {
                            <mat-option [value]="pool">{{ pool }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-3">
              <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="isResetToNeutralInProgress" (click)="onFlashResetToNeutral()">
                {{ isResetToNeutralInProgress ? 'Resetting...' : 'Reset to Neutral' }}
              </button>
            </div>

            <div class="col-3">
                <div style="margin-top:20px;">
                    <mat-slide-toggle [ngModel]="allowPassback" (ngModelChange)="onAllowPassbackChange($event)" [disabled]="isProfileUpdateInProgress">Allow Passback</mat-slide-toggle>
                </div>
            </div>
        </div>

        <mat-card class="card-grid-border" style="margin-top:10px;">
            <mat-card-content>
                <div class="row">
                    <div class="col-4">
                        <p><strong>Flash Account Number:</strong> {{ flashAccount.monthlyAccountNumber ?? '--' }}</p>
                        <p><strong>Source Id (Parker Id):</strong> {{ flashAccount.externalId || '--' }}</p>
                        <p><strong>Account Type:</strong> {{ flashAccount.accountType || '--' }}</p>
                        <p><strong>Status:</strong> {{ flashAccount.status || '--' }}</p>
                    </div>
                    <div class="col-4">
                        <p><strong>Profile:</strong> {{ flashAccount.profile || '--' }}</p>
                        <p><strong>Pool:</strong> {{ flashAccount.poolName || '--' }}</p>
                        <p><strong>Parks:</strong> {{ flashAccount.parks ?? '--' }}</p>
                        
                    </div>
                    <div class="col-4">
                        <p><strong>Company:</strong> {{ flashAccount.companyName || '--' }}</p>
                        <p><strong>Valid Until:</strong> {{ flashAccount.validUntil ? (flashAccount.validUntil | date: 'MM/dd/yyyy') : 'No End Date' }}</p>
                        <p><strong>Contacts:</strong> {{ flashAccount.contacts.length }}</p>
                        <p><strong>Vehicles:</strong> {{ flashAccount.cars.length }}</p>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <!-- TEMPORARY Flash certification evidence for GetMonthlyAccount / GetMonthlyContact /
             GetMonthlyVehicle. Delete this block, onLoadCertificationData and the service call once
             the certification screenshots are taken. -->
        <div style="margin-top:20px;">
            <button type="button" class="btn btn-primary ace-blue" [disabled]="isCertificationLoadInProgress" (click)="onLoadCertificationData()">
                {{ isCertificationLoadInProgress ? 'Pulling...' : 'Pull Flash Data (Certification)' }}
            </button>
            <span class="gray-text" style="margin-left:10px;font-size:13px;">GetMonthlyAccount / GetMonthlyContact / GetMonthlyVehicle</span>
        </div>

        @if (certificationData) {
            <mat-card class="card-grid-border" style="margin-top:10px;">
                <mat-card-content>
                    <h4 style="margin-bottom:10px;">Account Data <span class="gray-text" style="font-size:13px;font-weight:normal;">(GetMonthlyAccount1)</span></h4>
                    <div class="row">
                        @for (field of toDisplayFields(certificationData.account); track field.key) {
                            <div class="col-4"><p style="margin-bottom:4px;"><strong>{{ field.key }}:</strong> {{ field.value }}</p></div>
                        }
                    </div>

                    @for (entry of certificationData.contacts; track $index) {
                        <h4 style="margin-top:20px;margin-bottom:10px;">Contact Data {{ $index + 1 }} <span class="gray-text" style="font-size:13px;font-weight:normal;">(GetMonthlyContact1)</span></h4>
                        <div class="row">
                            @for (field of toDisplayFields(entry.contact); track field.key) {
                                <div class="col-4"><p style="margin-bottom:4px;"><strong>{{ field.key }}:</strong> {{ field.value }}</p></div>
                            }
                        </div>
                    }
                    @if (certificationData.contacts.length === 0) {
                        <h4 style="margin-top:20px;">Contact Data</h4>
                        <p class="gray-text">This Flash account has no contacts.</p>
                    }

                    @for (entry of certificationData.vehicles; track $index) {
                        <h4 style="margin-top:20px;margin-bottom:10px;">Vehicle Data {{ $index + 1 }} <span class="gray-text" style="font-size:13px;font-weight:normal;">(GetMonthlyVehicle1)</span></h4>
                        <div class="row">
                            @for (field of toDisplayFields(entry.vehicle); track field.key) {
                                <div class="col-4"><p style="margin-bottom:4px;"><strong>{{ field.key }}:</strong> {{ field.value }}</p></div>
                            }
                        </div>
                    }
                    @if (certificationData.vehicles.length === 0) {
                        <h4 style="margin-top:20px;">Vehicle Data</h4>
                        <p class="gray-text">This Flash account has no vehicles.</p>
                    }
                </mat-card-content>
            </mat-card>
        }
    }
    @else {
        <!-- No Flash account - offer to add this parker to Flash -->
        <h4>Add Parker to Flash</h4>
        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:5px;" [disabled]="isAddAccountInProgress" (click)="onAddParkerToFlash()">
          {{ isAddAccountInProgress ? 'Adding...' : 'Add Flash Profile' }}
        </button>

        <!-- TEMPORARY test harness for SetMonthlyAccountExternalID against a hardcoded Flash account. -->
        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="isConvertExternalAccountInProgress" (click)="onConvertExternalAccount()">
          {{ isConvertExternalAccountInProgress ? 'Converting...' : 'Convert External Account' }}
        </button>
        <span class="gray-text" style="margin-left:10px;font-size:13px;">Links Flash account {{ testFlashAccountNumber }} to this Parker.</span>
    }

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    <hr />

  </mat-card-actions>
</mat-card>





